import { tx as translateInterfaceText } from '@/utils/i18n';
import perfectPayLogo from '@/assets/parceiros/perfectPay.png';
import monetizzeLogo from '@/assets/parceiros/monetizze.png';
import vegaCheckoutLogo from '@/assets/parceiros/vegaCheckout.svg';
import replicLogo from '@/assets/parceiros/Logo_Replic_V2.svg';

export const partnersData = [
  {
    name: "Perfect Pay",
    logo: perfectPayLogo,
    get description() { return translateInterfaceText("Uma plataforma de processamento e gerenciamento de pagamentos online."); },
    category: "Plataforma de Pagamento",
    url: "https://perfectpay.com.br"
  },
  {
    name: "Monetizze",
    logo: monetizzeLogo,
    get description() { return translateInterfaceText("Fornece recursos para intermediar a relação entre consumidores, afiliados e produtores."); },
    category: "Plataforma de Pagamento",
    url: "https://monetizze.com.br"
  },
  {
    name: "Vega Checkout",
    logo: vegaCheckoutLogo,
    get description() { return translateInterfaceText("Checkout de alta conversão para negócios digitais."); },
    category: "Checkout de Pagamento",
    url: "https://vegacheckout.com.br"
  },
  {
    name: "Replic",
    logo: replicLogo,
    get description() { return translateInterfaceText("Crie e clone sites com IA que permite personalizar e hospedar páginas web em segundos."); },
    category: "Criação e clonador de Sites",
    url: "https://replic.com.br"
  }
];
